import React, { useState } from 'react';
import { Box, TextButton } from '@wix/design-system';
import { ChevronDown, ChevronUp } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { communityNavSubHeaderDataHooks } from '../CommunityNavSubHeader.dataHooks';
import CommunityNavModal from './CommunityNavModal/CommunityNavModal';
import DiscordButton from '../DiscordButton';

interface Props {
  className?: string;
}

const CommunityNavSubHeaderMobile = ({ className }: Props) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <header
        data-hook={communityNavSubHeaderDataHooks.root()}
        style={{ overflow: 'hidden' }}
        className={className ?? ''}
      >
        <Box
          direction="horizontal"
          align="space-between"
          verticalAlign="middle"
          padding="12px SP6"
          dataHook={communityNavSubHeaderDataHooks.root()}
        >
          <TextButton
            as="button"
            skin="dark"
            size="medium"
            weight="normal"
            suffixIcon={isModalOpen ? <ChevronUp /> : <ChevronDown />}
            dataHook={communityNavSubHeaderDataHooks.mobileTrigger()}
            onClick={() => setIsModalOpen(true)}
          >
            {t('marketplace.community-nav-sub-header.title')}
          </TextButton>
          <DiscordButton isSmallLabel />
        </Box>
      </header>

      <CommunityNavModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default CommunityNavSubHeaderMobile;
